// features/employee/fund/components/EmployeeFundSummaryCard.jsx
import { InfoCircleOutlined } from "@ant-design/icons";
import { Col, Flex, Row, Select } from "antd";
import { useTranslation } from "react-i18next";
import styles from "../styles/EmployeeFund.module.css";

const yearOptions = (currentBuddhistYear, lang) =>
    Array.from({ length: 5 }, (_, i) => currentBuddhistYear - i).map((y) => ({
        value: y,
        label: lang == "en" ? `${y}` : `ปี ${y + 543}`,
    }));

const formatBaht = (value) =>
    (Number(value) || 0).toLocaleString("th-TH", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

const StatPanel = ({ label, value, year, onYearChange, years, tooltip }) => {
    const { t } = useTranslation();
    return (
        <Flex vertical gap={4}>
            <Flex align="center" justify="space-between">
                <span className={styles.statLabel}>
                    {label} {tooltip && <InfoCircleOutlined style={{ color: "#98A2B3" }} />}
                </span>
                <Select size="small" value={year} options={years} onChange={onYearChange} style={{ width: 100 }} />
            </Flex>
            <span className={styles.statValue}>
                {formatBaht(value)} {t("baht") || "บาท"}
            </span>
        </Flex>
    );
};

const EmployeeFundSummaryCard = ({
    fundCount = 0,
    summary,
    year,
    onYearChange,
    currentBuddhistYear,
    asOfDate,
}) => {
    const { t, i18n } = useTranslation();
    const years = yearOptions(currentBuddhistYear, i18n.language);

    return (
        <div className={styles.summaryCard}>
            <Row gutter={24} align="middle">
                <Col span={5}>
                    <Flex align="center" gap={12}>
                        <div className={styles.summaryIcon}>🗂️</div>
                        <Flex vertical>
                            <span className={styles.statLabel}>{t("employeeFund.label.fundsJoined") || "กองทุนที่เข้าร่วม"}</span>
                            <span className={styles.statValue}>
                                {fundCount} {t("employeeFund.label.funds") || "กองทุน"}
                            </span>
                        </Flex>
                    </Flex>
                </Col>

                <Col span={19}>
                    <Row gutter={24}>
                        <Col span={8}>
                            <StatPanel
                                label={t("employeeFund.label.employeeAccumulated") || "ยอดสะสมของพนักงาน"}
                                tooltip
                                value={summary?.employeeAccumulatedTotal}
                                year={year}
                                years={years}
                                onYearChange={onYearChange}
                            />
                        </Col>
                        <Col span={8}>
                            <StatPanel
                                label={t("employeeFund.label.companyContributed") || "ยอดสมทบจากบริษัท"}
                                tooltip
                                value={summary?.companyContributedTotal}
                                year={year}
                                years={years}
                                onYearChange={onYearChange}
                            />
                        </Col>
                        <Col span={8}>
                            <StatPanel
                                label={t("employeeFund.label.totalAccumulated") || "ยอดรวมสะสม"}
                                tooltip
                                value={summary?.totalAccumulated}
                                year={year}
                                years={years}
                                onYearChange={onYearChange}
                            />
                        </Col>
                    </Row>
                </Col>
            </Row>
            {asOfDate && (
                <div className={styles.statAsOf} style={{ marginTop: 8 }}>
                    {t("employeeFund.label.asOfDate") || "ข้อมูล ณ วันที่"} {asOfDate}
                </div>
            )}
        </div>
    );
};

export default EmployeeFundSummaryCard;
